import { useQuery } from "@tanstack/react-query";
import {
	getGasConsumption,
	type GetGasConsumptionParams,
} from "../repositories/GasConsumptionRepository";

type UseGasConsumptionParams = Omit<GetGasConsumptionParams, "signal"> & {
	enabled?: boolean;
};

export const useGasConsumption = ({
	start,
	end,
	enabled = true,
}: UseGasConsumptionParams) => {
	return useQuery({
		queryKey: ["gasConsumption", start, end],
		queryFn: ({ signal }) => getGasConsumption({ start, end, signal }),
		enabled: enabled && !!start && !!end,
		refetchOnWindowFocus: false,
		refetchOnReconnect: false,
	});
};
